"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteShareConfig = deleteShareConfig;
Object.defineProperty(exports, "getImagePrefix", {
  enumerable: true,
  get: function get() {
    return _memberManagement.getImagePrefix;
  }
});
exports.getPageShareConfig = getPageShareConfig;
exports.getShareConfigDetail = getShareConfigDetail;
Object.defineProperty(exports, "queryPageList", {
  enumerable: true,
  get: function get() {
    return _popupConfig.queryPageList;
  }
});
exports.saveShareConfig = saveShareConfig;
exports.updateShareConfig = updateShareConfig;
Object.defineProperty(exports, "uploadPopupImage", {
  enumerable: true,
  get: function get() {
    return _popupConfig.uploadPopupImage;
  }
});
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
var _popupConfig = require("@/api/popup/popupConfig");
var _memberManagement = require("@/api/member/memberManagement");
/**
 * 分页查询页面分享配置
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
function getPageShareConfig(params) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateShareConfig/page',
    method: 'get',
    params: params
  });
}

/**
 * 保存分享配置（新增）
 * @param {Object} data - 分享配置数据
 * @returns {Promise}
 */
function saveShareConfig(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateShareConfig',
    method: 'post',
    data: data
  });
}

/**
 * 修改分享配置
 * @param {Object} data - 分享配置数据
 * @returns {Promise}
 */
function updateShareConfig(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateShareConfig',
    method: 'put',
    data: data
  });
}

/**
 * 删除分享配置
 * @param {Long} id - 分享配置ID
 * @returns {Promise}
 */
function deleteShareConfig(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateShareConfig",
    method: 'delete',
    params: {
      id: id
    }
  });
}

/**
 * 获取分享配置详情
 * @param {Long} id - 分享配置ID
 * @returns {Promise}
 */
function getShareConfigDetail(id) {
  return (0, _requestAuth.default)({
    url: "/xyDecorateShareConfig/".concat(id),
    method: 'get'
  });
}

// 导出图片上传和获取前缀的方法